export const ArrowDownIcon = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2331_22494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68336 5.68126L1 2.97256L1.63327 2.33331L4 4.72328L6.36673 2.33331L7 2.97256L4.31664 5.68126L4 5.99998L3.68336 5.68126Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2331_22494">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
